import React                  from 'react';
import { TemplateDialogModel }     from '../schedule/TemplateDialogModel';
import { TemplateGridView }        from '../schedule/TemplateDialog';
import { Theme, makeStyles }       from '../utility/styles';
import SettingsModel               from './SettingsModel';
import DefaultEditFormView         from './DefaultEditFormView';

const styles = (_theme: Theme) => ({
  form: {
    flex: '0 0 auto',
    marginBottom: '10px',
  },
  fields: {
    flex: '0 0 auto',
  },
  fieldContainer: {
    width: '100%',
    margin: '0px 0px 15px 0px !important',
    '& > div': {
      display: 'flex',
    },
  },
  gridHeaderRoot: {
    width: '75%',
    margin: '0px 0px 5px 0px',
  },
  gridContainer: {
    margin: '0px',
  },
});

const useStyles = makeStyles(styles);

const TemplateEditorView = React.memo(({ editor }: { editor: TemplateDialogModel, settings: SettingsModel }) => {
  const classes = useStyles();
  return (
    < >
      <DefaultEditFormView editor={editor} classes={{form: classes.form, fields: classes.fields, fieldContainer: classes.fieldContainer}} />
      <TemplateGridView model={editor.timecardTemplateGridModel} classes={{gridHeaderRoot: classes.gridHeaderRoot, gridContainer: classes.gridContainer}} />
    </>
  );
});

export default TemplateEditorView;
